import { render, staticRenderFns } from "./RatingDistribution.vue?vue&type=template&id=27a9a282"
import script from "./RatingDistribution.vue?vue&type=script&lang=js"
export * from "./RatingDistribution.vue?vue&type=script&lang=js"
import style0 from "./RatingDistribution.vue?vue&type=style&index=0&id=27a9a282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports